<template>
<div class="row justify-content-center mt-0">
    <fieldset style="text-align: left;padding: 30px;">
        <div class="row ">
            <div class="col-md-12">
                <h5 clas>Event Assesment</h5>
            </div>
        </div>
        <div class="row mt-5">
            <vs-tabs class="custom-tabs">
                <vs-tab label="Pre & Post">
                    <div class="row">
                        <div class="col-sm-12 mt-5">
                            <div class="row form-row text-dark" v-if="addPreassessmentForm == true">
                                <h6 class="sub-frm-title">Add Assessment Questions</h6>

                                <div class="row form-row">
                                    <div class="col-md-4">
                                        <label style="color: #07a7e19c !important;" for="no_of_question">
                                            <b>No. of question(s)</b>
                                            <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                        </label>
                                        <input type="number" min="1" v-model="no_of_question" class="form-control" placeholder="Enter no. of questions you want to add..." />
                                    </div>
                                    <div class="col-md-2">
                                        <vs-button color="#28a745" type="filled" style="margin-top:26px" @click="addAllQuestions()" :disabled="allQuestionsArr.length === 0">Add All Questions</vs-button>
                                    </div>
                                    <div class="col-md-4">
                                        <label style="color: #07a7e19c !important;" for="no_of_question">
                                            <b>Search Question</b>
                                        </label>
                                        <input type="text" v-model="searchQuery" class="form-control" placeholder="Search ..." />
                                    </div>
                                </div>

                                <div style="width:100%;">
                                    <vs-collapse accordion>
                                        <vs-collapse-item>
                                            <div slot="header" style="margin:5px 5px;">
                                                <vs-button color="primary" type="filled">Use Filter</vs-button>
                                            </div>
                                            <div class="row" style="background-color:#f3f3f3;border-radius:5px;margin:20px 0px;width:100%;">
                                                <div class="col-md-4">
                                                    <p style="margin-bottom:0px;" class="mt-1">
                                                        <b>Thematic Area</b>
                                                    </p>
                                                    <div class="mt-2">
                                                        <vs-row v-if="thematicArr">
                                                            <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="6" v-for="(item,index) in thematicArr" v-bind:key="index">
                                                                <div class="centerx">
                                                                    <vs-chip color="#24c1a0" style="font-size:12px;padding:8px;text-align:center">{{item.name}}</vs-chip>
                                                                </div>
                                                            </vs-col>
                                                        </vs-row>
                                                    </div>
                                                </div>
                                                <div class="col-md-4 level-radios" style="text-align:center;">
                                                    <p style="margin-bottom:0px;" class="mt-1">
                                                        <b>Question Level</b>
                                                    </p>
                                                    <ul class="leftx mt-2" style="display:inline-flex;">
                                                        <li>
                                                            <vs-radio v-model="radios1" vs-value="6" class="mr-2">Basic
                                                            </vs-radio>
                                                        </li>
                                                        <li>
                                                            <vs-radio v-model="radios1" vs-value="7" class="mr-2">Intermediate
                                                            </vs-radio>
                                                        </li>
                                                        <li>
                                                            <vs-radio v-model="radios1" vs-value="8" class="mr-2">Advance</vs-radio>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div class="col-md-4">
                                                    <p style="text-align:center;margin-bottom:0px;" class="mt-1">
                                                        <b>Previous  Event</b>
                                                    </p>

                                                    <selectize id="select-state" v-model="previoustrainingSelected" :settings="previoustrainingSettings">
                                                        <option v-for="(item,index) in previousTrainingArr" :key="index" :value="item.id">
                                                            {{item.title}}
                                                        </option>
                                                    </selectize>
                                                </div>
                                                <div class="col-md-12">
                                                    <div class="text-center" style="margin-bottom:10px;">
                                                        <b-button pill variant="outline-primary" @click="filterQuestions()" size="sm" class="mr-1">Search</b-button>
                                                        <b-button class="mr-1" pill variant="ouline-success" @click="resetFormElements()" size="sm">Reset</b-button>
                                                    </div>
                                                </div>

                                                <div style="height:165px"></div>
                                            </div>
                                        </vs-collapse-item>
                                    </vs-collapse>
                                </div>

                                <div class="col-sm-12 mb-2 mt-3">
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <h5 style="color:rgb(108, 117, 125);">
                                                Question Level Percentage
                                            </h5>
                                            <vs-row>
                                                <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="3">
                                                    <div class="centerx">
                                                        <vs-chip color="#5DADE2" style="font-size:15px;">
                                                            <Strong style="font-size:13px; padding:5px; margin-left: 5px">B :</Strong>
                                                            {{easyPercent}}%
                                                        </vs-chip>
                                                    </div>
                                                </vs-col>
                                                <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="3">
                                                    <div class="centerx">
                                                        <vs-chip color="#ffc107" style="font-size:15px;">
                                                            <Strong style="font-size:13px; padding:5px; margin-left: 5px">I :</Strong>
                                                            {{mediumPercent}}%
                                                        </vs-chip>
                                                    </div>
                                                </vs-col>
                                                <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="3">
                                                    <div class="centerx">
                                                        <vs-chip color="#dc3545" style="font-size:15px;">
                                                            <Strong style="font-size:13px; padding:5px; margin-left: 5px">A :</Strong>
                                                            {{hardPercent}}%
                                                        </vs-chip>
                                                    </div>
                                                </vs-col>
                                            </vs-row>
                                        </div>

                                        <div class="col-sm-6">
                                            <h5 style="color:rgb(108, 117, 125);">Thematic Area</h5>
                                            <vs-row v-if="thematicArr">
                                                <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="3" v-for="(item,index) in thematicArr" v-bind:key="index">
                                                    <div class="centerx">
                                                        <vs-chip color="#24c1a0" style="font-size:12px;padding:8px">{{item.name}}</vs-chip>
                                                    </div>
                                                </vs-col>
                                            </vs-row>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <vs-button color="primary" type="filled" :style="{marginLeft:'18px'}" @click="openModal">
                                            Add New Question</vs-button>
                                    </div>
                                </div>

                                <div class="col-sm-6 mt-5" style="border: 1px dotted #07a7e14f;" v-if="questionForm == true">
                                    <div class="mb-3 repository-title">Repository</div>
                                    <div v-for="(item,index) in filterData" v-bind:key="index">
                                        <b-card class="mb-3">
                                            <b-card-text>
                                                <h6>
                                                    <strong>Q {{index+1}})</strong>
                                                    {{item[0].qtitle}}
                                                    <span></span>
                                                </h6>
                                            </b-card-text>
                                            <div>
                                                <b-badge class="p-2 mr-1" variant="secondary" v-if="item[0].qfrequency != null">F : {{item[0].qfrequency}}</b-badge>
                                                <b-badge class="p-2 mr-1" variant="secondary" v-else>F : 0</b-badge>
                                                <b-badge class="p-2 mr-1 mb-2 bg-blue" v-if="item[0].qlevel == 6">B</b-badge>
                                                <b-badge class="p-2 mr-1 mb-2 " variant="warning" v-else-if="item[0].qlevel == 7">I</b-badge>
                                                <b-badge class="p-2 mr-1 mb-2" variant="danger" v-else-if="item[0].qlevel == 8">A</b-badge>
                                                <b class="text-ans"> Correct Ans: </b>

                                                <b-badge :id="index+1" class="mb-3" variant="success" v-for="(option, index2) in item[1]" v-bind:key="index2">
                                                    <div v-if="option.opstatus == 1" class="ans">
                                                        {{ option.otitle }}
                                                    </div>
                                                </b-badge>
                                                <b-button style="float:right;" id="moveButton" href="#" @click="moveQuestion(item)" size="sm" variant="primary">Add</b-button>
                                            </div>
                                        </b-card>
                                    </div>
                                </div>

                                <div class="col-sm-6 mt-5" style="border: 1px dotted #07a7e14f;" v-if="filterForm == true">
                                    <div class="mb-3 filtered-title">Filtered Repo</div>
                                    <span v-if="allQuestionsArr.length > 0">
                                        <div v-for="(item,index) in allQuestionsArr" v-bind:key="item[0].qid">
                                            <b-card class="mb-3">
                                                <b-card-text>
                                                    <h6>
                                                        <strong>Q {{index+1}})</strong>
                                                        {{item[0].qtitle}}
                                                        <span></span>
                                                    </h6>
                                                </b-card-text>
                                                <div>
                                                    <b-badge class="p-2 mr-1" variant="secondary" v-if="item[0].qfrequency != null">F : {{item[0].qfrequency}}</b-badge>
                                                    <b-badge class="p-2 mr-1" variant="secondary" v-else>F : 0</b-badge>

                                                    <b-badge class="p-2 mr-1 mb-2 bg-blue" v-if="item[0].qlevel == 6">B</b-badge>
                                                    <b-badge class="p-2 mr-1 mb-2" variant="warning" v-else-if="item[0].qlevel == 7">I</b-badge>
                                                    <b-badge class="p-2 mr-1 mb-2" href="#" variant="danger" v-else-if="item[0].qlevel == 8">A</b-badge>

                                                    <b class="text-ans"> Correct Ans: </b>

                                                    <b-badge :id="index+1" class="mb-3" variant="success" v-for="(option, index2) in item[1]" v-bind:key="index2">
                                                        <div v-if="option.opstatus == 1" class="ans">
                                                            {{ option.otitle }}
                                                        </div>
                                                    </b-badge>

                                                    <b-button style="float:right;" href="#" size="sm" @click="moveQuestion(item)" variant="primary">Add</b-button>
                                                </div>
                                            </b-card>
                                        </div>
                                    </span>
                                    <span class="text-danger" v-else>
                                        <b>Warning! Questions were not found according to
                                            search.</b>
                                    </span>
                                </div>

                                <div class="col-sm-6 mt-5" style="border: 1px dotted #07a7e14f; border-left:none;">
                                    <div class="mb-3 ml-1 selected-title">Selected</div>

                                    <div v-if="selectedQuestionsArr.length > 0">
                                        <div :class="{ 'dragging-container': isDragging }">
                                            <draggable v-model="selectedQuestionsArr" :options="{ animation: 200 }" @start="onDragStart" @end="onDragEnd">
                                                <div v-for="(item,index) in selectedQuestionsArr" v-bind:key="index" id="scrollToQuestion" :class="{
                                                'dragging-item': draggingIndex === index,
                                                'new-position': newPositionIndex === index,
                                                'grab': !isDragging,
                                                'grabbing': isDragging,
                                                }" @mousedown="onMouseDown" @mouseup="onMouseUp">
                                                    <b-card class="mb-3 ">
                                                        <b-card-text>
                                                            <h6>
                                                                <strong>Q {{index+1}})</strong>
                                                                {{item[0].qtitle}}
                                                                <span></span>
                                                            </h6>
                                                        </b-card-text>
                                                        <div>
                                                            <b-badge class="p-2 mr-1" variant="secondary" v-if="item[0].qfrequency != null">F : {{item[0].qfrequency + 1}}</b-badge>
                                                            <b-badge class="p-2 mr-1" variant="secondary" v-else>F : 1</b-badge>

                                                            <b-badge class="p-2 mr-1 mb-2 bg-blue" v-if="item[0].qlevel == 6">B</b-badge>
                                                            <b-badge class="p-2 mr-1 mb-2" variant="warning" v-else-if="item[0].qlevel == 7">I</b-badge>
                                                            <b-badge class="p-2 mr-1 mb-2" variant="danger" v-else-if="item[0].qlevel == 8">A</b-badge>
                                                            <b-button style="float:right;" href="#" size="sm" @click="removeQuestion(item)" variant="danger">Remove</b-button>
                                                        </div>

                                                        <div class="dots-icon">
                                                            <i class="material-icons" style="font-size: 20px;">drag_indicator</i>
                                                        </div>
                                                    </b-card>
                                                </div>
                                            </draggable>
                                        </div>

                                        <div v-if="this.showAssessmentTable == true">
                                            <div class="mb-5">
                                                <b-button id="mybutton" @click="submitForm()" variant="primary" style="float:right;" size="sm">Create</b-button>
                                            </div>
                                        </div>
                                        <div v-else-if="this.showAssessmentTable == false">
                                            <div class="mb-5">
                                                <b-button id="mybutton" @click="submitEditForm()" variant="primary" style="float:right;" size="sm">Update</b-button>
                                                <b-button variant="outline-dark" @click="isExistPreAssessment()" class="mr-1 float-right" size="sm">Cancel</b-button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="text-center" style="margin-top: 30px;" v-else>
                                        <b class="text-danger">Warning! No question was selected yet.</b>
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="existPreassessmentForm == true">
                                <h6 class="sub-frm-title">
                                    Pre & Post assessments have been created for this training.
                                </h6>

                                <div class="col-sm-12 mb-2 mt-3">
                                    <div class="row">
                                        <div class="col-sm-8">
                                            <h6 style="color:rgb(108, 117, 125);">
                                                Question Level Percentage
                                            </h6>
                                            <vs-row>
                                                <vs-col vs-type="flex" vs-align="center" vs-w="3">
                                                    <div class="centerx">
                                                        <vs-chip color="success" style="font-size:15px;">
                                                            <Strong style="font-size:15px; padding-right:5px;">B :</Strong>
                                                            {{assessmentShowArr[0].easy_percent }}%
                                                        </vs-chip>
                                                    </div>
                                                </vs-col>
                                                <vs-col vs-type="flex" vs-align="center" vs-w="3">
                                                    <div class="centerx">
                                                        <vs-chip color="warning" style="font-size:15px;">
                                                            <Strong style="font-size:15px; padding-right:5px;">I :</Strong>
                                                            {{assessmentShowArr[0].medium_percent }}%
                                                        </vs-chip>
                                                    </div>
                                                </vs-col>
                                                <vs-col vs-type="flex" vs-align="center" vs-w="3">
                                                    <div class="centerx">
                                                        <vs-chip color="danger" style="font-size:15px;">
                                                            <Strong style="font-size:15px; padding-right:5px;">A :</Strong>
                                                            {{assessmentShowArr[0].hard_percent }}%
                                                        </vs-chip>
                                                    </div>
                                                </vs-col>
                                            </vs-row>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="table-responsive" v-if="assessmentShowArr.length > 0 & this.showAssessmentTable == true">
                                <div class="mb-1" style="float:right">
                                    <b-button variant="outline-primary" class="mr-1" size="sm" @click="editAssesment()">Edit</b-button>
                                    <b-button @click="deleteAssesment()" variant="outline-danger" class="mr-1" size="sm">Delete</b-button>
                                </div>
                                <table class="table table-hover">
                                    <tr>
                                        <th>Sr#</th>
                                        <th>Title</th>
                                        <th>Question Level</th>
                                        <th>Added at</th>
                                    </tr>
                                    <tr v-for="(item,index) in assessmentShowArr" v-bind:key="index">
                                        <td>{{index+1}}</td>
                                        <td>{{item.question.title}}</td>
                                        <td v-if="item.question.level == 6">Basic</td>
                                        <td v-else-if="item.question.level == 7">Intermediate</td>
                                        <td v-else-if="item.question.level == 8">Advance</td>
                                        <td v-else>
                                            <code>NULL</code>
                                        </td>
                                        <td>
                                            {{item.createdAt | formatDate}}
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </vs-tab>

                <template>
                    <div v-if="isModalOpen" class="modal">
                        <div class="modal-content">
                            <span class="close" @click="closeModal">&times;</span>
                            <div>
                                <form @submit.prevent="createQuestionBank" autocomplete="off">
                                    <div class="form-group">
                                        <h5>Create New Question</h5>
                                        <div class="row">
                                            <div class="col-sm-8">
                                                <label class="font-weight-bold">
                                                    Thematic Area
                                                    <span style="color: rgba(255, 0, 0, 0.78)">*</span>
                                                </label>
                                                <selectize id="select-state" v-model="thematicAreaSelected" :settings="thematicAreaSettings">
                                                    <option v-for="(item, index) in thematicAreasLoad" :key="index" :value="item.id">
                                                        {{ item.name }}
                                                    </option>
                                                </selectize>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-8">
                                                <label class="font-weight-bold">Question Level</label>
                                                <selectize class id="select-state" v-model="level" :settings="levelSetting" :searchable="true">
                                                    <option v-for="(item, index) in leveltitleArr" :key="index" :value="item.value">
                                                        {{ item.text }}
                                                    </option>
                                                </selectize>
                                            </div>
                                            <div class="col-sm-4">
                                                <div style="display: inline-flex; margin-top: 23px">
                                                    <label style="margin-right: 10px">
                                                        <b>Type:</b>
                                                    </label>
                                                    <div class="form-check">
                                                        <vs-radio v-model="radiostype" vs-value="checkbox">MCQS</vs-radio>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-sm-8">
                                                <div class="pt-2">
                                                    <label class="font-weight-bold">Question statement</label>
                                                    <b-form-textarea id="textarea-rows" v-model="commonQuestion" rows="4"></b-form-textarea>
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div v-if="radiostype == 'checkbox'" class="form-group  pt-2">
                                                    <label class="">
                                                        <b>Option:</b>
                                                    </label>

                                                    <div class="form-check">
                                                        <vs-radio v-model="numbertype" vs-name="numbering" vs-value="numberLimit">1-2</vs-radio>
                                                    </div>
                                                    <div class="form-check">
                                                        <vs-radio v-model="numbertype" vs-name="numbering" vs-value="numberLimit1">1-3</vs-radio>
                                                    </div>
                                                    <div class="form-check">
                                                        <vs-radio v-model="numbertype" vs-name="numbering" vs-value="numberLimit2">1-4</vs-radio>
                                                    </div>
                                                    <div class="form-check">
                                                        <vs-radio v-model="numbertype" vs-name="numbering" vs-value="number">1-5</vs-radio>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <template v-if="numbertype == 'numberLimit'">
                                                <div class="col-sm-8">
                                                    <div class="d-flex justify-content-between mb-3" style="margin-bottom: 8px">
                                                        <div class="mt-3">
                                                            <span class="p-2">1</span>
                                                        </div>
                                                        <div class="mt-2 d-flex" style="width: 100%">
                                                            <vs-input class="inputx" placeholder="Option 1" v-model="qCheckboxArr[0].option1" />
                                                            <div style="padding: 6px 0px 0px 6px">
                                                                <vs-radio color="success" v-model="correct1" vs-name="radios1" vs-value="1"></vs-radio>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="d-flex justify-content-between mb-3" style="margin-bottom: 8px">
                                                        <div class style="margin-top: -9px">
                                                            <span class="p-2">2</span>
                                                        </div>
                                                        <div class="mt-minus-1 d-flex" style="width: 100%">
                                                            <vs-input class="inputx" placeholder="Option 2" v-model="qCheckboxArr[0].option2" />
                                                            <div style="padding: 6px 0px 0px 6px">
                                                                <vs-radio color="success" v-model="correct2" vs-name="radios1" vs-value="1"></vs-radio>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="d-flex justify-content-end" style="width: 100%">
                                                        <button type="submit" class="btn btn-primary btn-sm">
                                                            Save
                                                        </button>
                                                    </div>
                                                </div>
                                            </template>

                                            <template v-if="numbertype == 'numberLimit1'">
                                                <div class="col-sm-8">
                                                    <div class="d-flex justify-content-between mb-3" style="margin-bottom: 8px">
                                                        <div class="mt-3">
                                                            <span class="p-2">1</span>
                                                        </div>
                                                        <div class="mt-2 d-flex" style="width: 100%">
                                                            <vs-input class="inputx" placeholder="Option 1" v-model="qCheckboxArr[0].option1" />

                                                            <div style="padding: 6px 0px 0px 6px">
                                                                <vs-radio color="success" v-model="correct1" vs-name="radios1" vs-value="1"></vs-radio>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="d-flex justify-content-between mb-3" style="margin-bottom: 8px">
                                                        <div class style="margin-top: -9px">
                                                            <span class="p-2">2</span>
                                                        </div>
                                                        <div class="mt-minus-1 d-flex" style="width: 100%">
                                                            <vs-input class="inputx" placeholder="Option 2" v-model="qCheckboxArr[0].option2" />

                                                            <div style="padding: 6px 0px 0px 6px">
                                                                <vs-radio color="success" v-model="correct2" vs-name="radios1" vs-value="1"></vs-radio>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="d-flex justify-content-between mb-3" style="margin-bottom: 8px">
                                                        <div class style="margin-top: -9px">
                                                            <span class="p-2">3</span>
                                                        </div>
                                                        <div class="mt-minus-2 d-flex" style="width: 100%">
                                                            <vs-input class="inputx" placeholder="Option 3" v-model="qCheckboxArr[0].option3" />

                                                            <div style="padding: 6px 0px 0px 6px">
                                                                <vs-radio color="success" v-model="correct3" vs-name="radios1" vs-value="1"></vs-radio>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="d-flex justify-content-end" style="width: 100%">
                                                        <button type="submit" class="btn btn-primary btn-sm">
                                                            Save
                                                        </button>
                                                    </div>
                                                </div>
                                            </template>

                                            <template v-if="numbertype == 'numberLimit2'">
                                                <div class="col-sm-8">
                                                    <div class="d-flex justify-content-between mb-3" style="margin-bottom: 8px">
                                                        <div class="mt-3">
                                                            <span class="p-2">1</span>
                                                        </div>
                                                        <div class="mt-2 d-flex" style="width: 100%">
                                                            <vs-input class="inputx" placeholder="Option 1" v-model="qCheckboxArr[0].option1" />

                                                            <div style="padding: 6px 0px 0px 6px">
                                                                <vs-radio color="success" v-model="correct1" vs-name="radios1" vs-value="1"></vs-radio>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="d-flex justify-content-between mb-3" style="margin-bottom: 8px">
                                                        <div class style="margin-top: -9px">
                                                            <span class="p-2">2</span>
                                                        </div>
                                                        <div class="mt-minus-1 d-flex" style="width: 100%">
                                                            <vs-input class="inputx" placeholder="Option 2" v-model="qCheckboxArr[0].option2" />

                                                            <div style="padding: 6px 0px 0px 6px">
                                                                <vs-radio color="success" v-model="correct2" vs-name="radios1" vs-value="1"></vs-radio>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="d-flex justify-content-between mb-3" style="margin-bottom: 8px">
                                                        <div class style="margin-top: -9px">
                                                            <span class="p-2">3</span>
                                                        </div>
                                                        <div class="mt-minus-2 d-flex" style="width: 100%">
                                                            <vs-input class="inputx" placeholder="Option 3" v-model="qCheckboxArr[0].option3" />

                                                            <div style="padding: 6px 0px 0px 6px">
                                                                <vs-radio color="success" v-model="correct3" vs-name="radios1" vs-value="1"></vs-radio>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="d-flex justify-content-between mb-3" style="margin-bottom: 8px">
                                                        <div class style="margin-top: -9px">
                                                            <span class="p-2">4</span>
                                                        </div>
                                                        <div class="mt-minus-3 d-flex" style="width: 100%">
                                                            <vs-input class="inputx" placeholder="Option 4" v-model="qCheckboxArr[0].option4" />

                                                            <div style="padding: 6px 0px 0px 6px">
                                                                <vs-radio color="success" v-model="correct4" vs-name="radios1" vs-value="1"></vs-radio>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="d-flex justify-content-end" style="width: 100%">
                                                        <button type="submit" class="btn btn-primary btn-sm">
                                                            Save
                                                        </button>
                                                    </div>
                                                </div>
                                            </template>

                                            <template v-if="numbertype == 'number'">
                                                <div class="col-sm-8">
                                                    <div class="d-flex justify-content-between mb-3" style="margin-bottom: 8px">
                                                        <div class="mt-3">
                                                            <span class="p-2">1</span>
                                                        </div>
                                                        <div class="mt-2 d-flex" style="width: 100%">
                                                            <vs-input class="inputx" placeholder="Option 1" v-model="qCheckboxArr[0].option1" />

                                                            <div style="padding: 6px 0px 0px 6px">
                                                                <vs-radio color="success" v-model="correct1" vs-name="radios1" vs-value="1"></vs-radio>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="d-flex justify-content-between mb-3" style="margin-bottom: 8px">
                                                        <div class style="margin-top: -9px">
                                                            <span class="p-2">2</span>
                                                        </div>
                                                        <div class="mt-minus-1 d-flex" style="width: 100%">
                                                            <vs-input class="inputx" placeholder="Option 2" v-model="qCheckboxArr[0].option2" />

                                                            <div style="padding: 6px 0px 0px 6px">
                                                                <vs-radio color="success" v-model="correct2" vs-name="radios1" vs-value="1"></vs-radio>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="d-flex justify-content-between mb-3" style="margin-bottom: 8px">
                                                        <div class style="margin-top: -9px">
                                                            <span class="p-2">3</span>
                                                        </div>
                                                        <div class="mt-minus-2 d-flex" style="width: 100%">
                                                            <vs-input class="inputx" placeholder="Option 3" v-model="qCheckboxArr[0].option3" />
                                                            <div style="padding: 6px 0px 0px 6px">
                                                                <vs-radio color="success" v-model="correct3" vs-name="radios1" vs-value="1"></vs-radio>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="d-flex justify-content-between mb-3" style="margin-bottom: 8px">
                                                        <div class style="margin-top: -9px">
                                                            <span class="p-2">4</span>
                                                        </div>
                                                        <div class="mt-minus-3 d-flex" style="width: 100%">
                                                            <vs-input class="inputx" placeholder="Option 4" v-model="qCheckboxArr[0].option4" />
                                                            <div style="padding: 6px 0px 0px 6px">
                                                                <vs-radio color="success" v-model="correct4" vs-name="radios1" vs-value="1"></vs-radio>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="d-flex justify-content-between mb-3" style="margin-bottom: 8px">
                                                        <div class style="margin-top: -9px">
                                                            <span class="p-2">5</span>
                                                        </div>
                                                        <div class="mt-minus-4 d-flex" style="width: 100%">
                                                            <vs-input class="inputx" placeholder="Option 5" v-model="qCheckboxArr[0].option5" />
                                                            <div style="padding: 6px 0px 0px 6px">
                                                                <vs-radio color="success" v-model="correct5" vs-name="radios1" vs-value="1"></vs-radio>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="d-flex justify-content-end" style="width: 100%">
                                                        <button type="submit" class="btn btn-primary btn-sm">
                                                            Save
                                                        </button>
                                                    </div>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </template>

                <vs-tab label="Facilitator's Feedback">
                    <div class="row">
                        <div class="col-sm-12 mt-5">
                            <div v-if="addTrainerFeedbackForm == true">
                                <div class="row form-row text-dark">
                                    <h6 class="sub-frm-title">Add Feedback questions</h6>
                                    <div class="col-sm-12"></div>
                                    <div class="col-sm-6 mt-2">
                                        <label style="color: #07a7e19c !important;margin-bottom:0px;" for="no_of_question_trainer">
                                            <b>Enter no. of question(s)</b>
                                            <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                        </label>

                                        <div class="mt-2">
                                            <input style="height: 34px !important;" type="number" v-model="no_of_question_trainer" class="form-control" placeholder="Enter no. of questions you want to add..." />
                                        </div>
                                    </div>

                                    <div class="col-sm-6 mt-2">
                                        <label style="color: #07a7e19c !important;margin-bottom:0px;" for="no_of_question">
                                            <b>Previous  Event</b>
                                            <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                        </label>

                                        <div class="mt-2">
                                            <selectize id="select-state" v-model="previoustrainingSelectedTrainer" :settings="previoustrainingSettings">
                                                <option v-for="(item,index) in previousTrainingArr" :key="index" :value="item.id">
                                                    {{item.title}}
                                                </option>
                                            </selectize>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6 mt-5" style="border: 1px dotted #07a7e14f;">
                                        <div class="mb-3 repository-title">Repository</div>
                                        <vs-tabs alignment="fixed">
                                            <vs-tab label="MCQ's">
                                                <b-card class="mb-3" v-for="(item,index) in allMcqsQuestionsArrTrainer" v-bind:key="index">
                                                    <b-card-text>
                                                        <h6>
                                                            <strong>Q{{index+1}})</strong>
                                                            {{item[0].qtitle}}
                                                            <span></span>
                                                        </h6>
                                                    </b-card-text>
                                                    <div>
                                                        <b-badge class="p-2 mr-1" href="#" variant="secondary" v-if="item[0].qfrequency != null">F : {{item[0].qfrequency}}</b-badge>
                                                        <b-badge class="p-2 mr-1" href="#" variant="secondary" v-else>F : 0</b-badge>

                                                        <b-button @click="moveMcqsQuestionTrainer(index,item[0].qid)" style="float:right;" href="#" size="sm" variant="primary">Add</b-button>
                                                    </div>
                                                </b-card>
                                            </vs-tab>

                                            <vs-tab label="Descriptive">
                                                <b-card class="mb-3" v-for="(item,index) in allDescQuestionsArrTrainer" v-bind:key="index">
                                                    <b-card-text>
                                                        <h6>
                                                            <strong>Q{{index+1}})</strong>
                                                            {{item[0].qtitle}}
                                                            <span></span>
                                                        </h6>
                                                    </b-card-text>
                                                    <div>
                                                        <b-badge class="p-2 mr-1" href="#" variant="secondary" v-if="item[0].qfrequency != null">F : {{item[0].qfrequency}}</b-badge>
                                                        <b-badge class="p-2 mr-1" href="#" variant="secondary" v-else>F : 0</b-badge>

                                                        <b-button @click="moveDescQuestionTrainer(index,item[0].qid)" style="float:right;" href="#" size="sm" variant="primary">Add</b-button>
                                                    </div>
                                                </b-card>
                                            </vs-tab>
                                        </vs-tabs>
                                    </div>

                                    <div class="col-sm-6 mt-5" style="border: 1px dotted #07a7e14f; border-left:none;">
                                        <div class="mb-3 ml-1 selected-title">Selected</div>
                                        <vs-tabs alignment="fixed">
                                            <vs-tab label="MCQ's">
                                                ({{this.selectedMcqsQuestionsArrTrainer.length }})

                                                <b-card class="mb-3" v-for="(item,index) in selectedMcqsQuestionsArrTrainer" v-bind:key="index">
                                                    <b-card-text>
                                                        <h6>
                                                            <strong>Q {{index+1}})</strong>
                                                            {{item[0].qtitle}}
                                                            <span></span>
                                                        </h6>
                                                    </b-card-text>
                                                    <div>
                                                        <b-badge class="p-2 mr-1" href="#" variant="secondary" v-if="item[0].qfrequency != null">F : {{item[0].qfrequency + 1}}</b-badge>
                                                        <b-badge class="p-2 mr-1" href="#" variant="secondary" v-else>F : 1</b-badge>

                                                        <b-button variant="danger" style="float:right;border:1px solid #f60404;" class="m-1" href="#" size="sm" @click="removeMcqsQuestionTrainer(index)">Remove</b-button>
                                                    </div>
                                                </b-card>
                                            </vs-tab>
                                            <vs-tab label="Descriptive">
                                                ({{this.selectedDescQuestionsArrTrainer.length}})

                                                <b-card class="mb-3" v-for="(item,index) in selectedDescQuestionsArrTrainer" v-bind:key="index">
                                                    <b-card-text>
                                                        <h6>
                                                            <strong>Q {{index+1}})</strong>
                                                            {{item[0].qtitle}}
                                                            <span></span>
                                                        </h6>
                                                    </b-card-text>
                                                    <div>
                                                        <b-badge class="p-2 mr-1" href="#" variant="secondary" v-if="item[0].qfrequency != null">F : {{item[0].qfrequency + 1}}</b-badge>
                                                        <b-badge class="p-2 mr-1" href="#" variant="secondary" v-else>F : 1</b-badge>

                                                        <b-button variant="danger" style="float:right;border:1px solid #f60404;" class="m-1" href="#" size="sm" @click="removeDescQuestionTrainer(index)">Remove</b-button>
                                                    </div>
                                                </b-card>
                                            </vs-tab>
                                        </vs-tabs>
                                        <div class="mb-5" v-if="this.selectedMcqsQuestionsArrTrainer.length > 0 | this.selectedDescQuestionsArrTrainer.length > 0">
                                            <b-button variant="primary" @click="submitFormTrainer()" style="float:right;" href="#" size="sm">Create</b-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="table-responsive" v-else-if="existTrainerFeedbackForm == true">
                                <h6 class="sub-frm-title">
                                    Facilitator's Feedback has been created for this training
                                </h6>

                                <div class="mb-1" style="float:right">
                                    <b-button variant="outline-primary" class="mr-1" size="sm" @click="editTrainerFeedback()">Edit</b-button>
                                    <!-- <b-button variant="outline-danger" class="mr-1" size="sm" @click="deleteTrainerFeedback()">Delete</b-button> -->
                                </div>
                                <table class="table table-hover">
                                    <tr>
                                        <th>Sr#</th>
                                        <th>Title</th>
                                        <th>Question Type</th>
                                        <th>Added at</th>
                                    </tr>
                                    <tr v-for="(item,index) in trainerFeedbackShowArr" v-bind:key="index">
                                        <td>{{index+1}}</td>
                                        <td>{{item.question.title}}</td>
                                        <td v-if="item.type == 'mcqs'">MCQ's</td>
                                        <td v-else-if="item.type == 'descriptive'">
                                            Descriptive
                                        </td>
                                        <td v-else>
                                            <code>NULL</code>
                                        </td>
                                        <td>
                                            {{item.createdAt | formatDate}}
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </vs-tab>
                <vs-tab label="Participant's Feedback">
                    <div class="row">
                        <div class="col-sm-12 mt-5">
                            <div class="row form-row text-dark" v-if="addTraineeFeedForm == true">
                                <h6 class="sub-frm-title">Add Feedback questions</h6>
                                <div class="col-sm-12"></div>
                                <div class="col-sm-6 mt-2">
                                    <label style="color: #07a7e19c !important;margin-bottom:0px;" for="no_of_question">
                                        <b>Enter no. of question(s)</b>
                                        <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                    </label>

                                    <div class="mt-2">
                                        <input type="number" style="height: 34px !important;" v-model="no_of_question_trainee" class="form-control" placeholder="Enter no. of questions you want to add..." />
                                    </div>
                                </div>

                                <div class="col-sm-6 mt-2">
                                    <label style="color: #07a7e19c !important;margin-bottom:0px;" for="no_of_question">
                                        <b>Previous  Event</b>
                                        <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                    </label>

                                    <div class="mt-2">
                                        <selectize id="select-state" v-model="previoustrainingSelectedTrainee" :settings="previoustrainingSettings">
                                            <option v-for="(item,index) in previousTrainingArr" :key="index" :value="item.id">
                                                {{item.title}}
                                            </option>
                                        </selectize>
                                    </div>
                                </div>
                                <div class="row w-100" style="margin-left:-8px">
                                    <div class="col-sm-6 mt-5" style="border: 1px dotted #07a7e14f; border-left:none;;" v-if="questionFormTrainee == true">
                                        <div class="mb-3 repository-title">Repository</div>
                                        <div v-for="(item,index) in allQuestionsArrTrainee" v-bind:key="index">
                                            <b-card class="mb-3">
                                                <b-card-text>
                                                    <h6>
                                                        <strong>Q {{index+1}})</strong>
                                                        {{item[0].qtitle}}
                                                        <span></span>
                                                    </h6>
                                                </b-card-text>
                                                <div>
                                                    <b-badge class="p-2 mr-1" href="#" variant="secondary" v-if="item[0].qfrequency != null">F : {{item[0].qfrequency}}</b-badge>
                                                    <b-badge class="p-2 mr-1" href="#" variant="secondary" v-else>F : 0</b-badge>

                                                    <b-collapse :id="index+1" class="mb-3" v-for="(option, index2) in item[1]" v-bind:key="index2">
                                                        <b-card v-if="option.opstatus == 1">{{ option.otitle }}</b-card>
                                                    </b-collapse>
                                                    <b-button style="float:right;" id="moveButton" href="#" @click="moveQuestionTrainee(index,item[0].qid)" size="sm" variant="primary">Add</b-button>
                                                </div>
                                            </b-card>
                                        </div>
                                    </div>

                                    <div class="col-sm-6 mt-5" style="border: 1px dotted #07a7e14f; border-left:none;">
                                        <div class="mb-3 ml-1 selected-title">Selected</div>
                                        <div v-if="selectedQuestionsArrTrainee.length > 0">
                                            <div v-for="(item,index) in selectedQuestionsArrTrainee" v-bind:key="index" id="scrollToQuestion">
                                                <b-card class="mb-3">
                                                    <b-card-text>
                                                        <h6>
                                                            <strong>Q {{index+1}}</strong>
                                                            {{item[0].qtitle}}
                                                            <span></span>
                                                        </h6>
                                                    </b-card-text>
                                                    <div>
                                                        <b-badge class="p-2 mr-1" href="#" variant="secondary" v-if="item[0].qfrequency != null">F : {{item[0].qfrequency + 1}}</b-badge>
                                                        <b-badge class="p-2 mr-1" href="#" variant="secondary" v-else>F : 1</b-badge>

                                                        <b-collapse :id="index+1" class="mb-3" v-for="(option, index2) in item[1]" v-bind:key="index2">
                                                            <b-card v-if="option.opstatus == 1">{{ option.otitle }}</b-card>
                                                        </b-collapse>
                                                        <b-button style="float:right;" href="#" size="sm" @click="removeQuestionTrainee(index)" variant="danger">Remove</b-button>
                                                    </div>
                                                </b-card>
                                            </div>
                                            <div class="mb-5">
                                                <b-button id="mybutton" @click="submitFormTrainee()" variant="primary" style="float:right;" size="sm">Create</b-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="table-responsive" v-else-if="existTraineeFeedForm == true">
                                <h6 class="sub-frm-title">
                                    Trainee Feedback has been created for this training
                                </h6>

                                <div class="mb-1" style="float:right">
                                    <b-button variant="outline-primary" class="mr-1" size="sm">Edit</b-button>
                                    <b-button variant="outline-danger" class="mr-1" size="sm">Delete</b-button>
                                </div>
                                <table class="table table-hover">
                                    <tr>
                                        <th>Sr#</th>
                                        <th>Title</th>
                                        <th>Added at</th>
                                    </tr>
                                    <tr v-for="(item,index) in traineeFeedbackShowArr" v-bind:key="index">
                                        <td>{{index+1}}</td>
                                        <td>{{item.question.title}}</td>
                                        <td>
                                            {{item.createdAt | formatDate}}
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </vs-tab>
            </vs-tabs>
        </div>
    </fieldset>
</div>
</template>

<script>
import axios from "axios";
import Selectize from "vue2-selectize";
import draggable from 'vuedraggable';


export default {
    data: () => ({
        trainingId: "",
        trainingCode: "",
        trainingTitle: "",
        startDate: "",
        endDate: "",
        searchQuery: "",
        no_of_question: 10,
        allQuestionsArr: [],
        filteredQuestionsArr: [],
        selectedQuestionsArr: [],

        currentx: 1,
        currentx2: 1,
        radios1: "",
        value1: [0, 50],
        thematicArr: [],
        thematicSelected: "",
        thematicSettings: {
            maxItems: 5
        },
        previousTrainingArr: [],
        previoustrainingSelected: "",
        previoustrainingSettings: {
            maxItems: 3,
            plugins: ["remove_button"]
        },

        isSidebar: false,
        questionForm: true,
        filterForm: false,
        addPreassessmentForm: true,
        existPreassessmentForm: false,
        showAssessmentTable: false,
        easyPercent: 0,
        easyPercentArr: [],
        mediumPercent: 0,
        mediumPercentArr: [],
        hardPercent: 0,
        hardPercentArr: [],
        thematicSelectedShowArr: [],
        thematicSelectedShow: "",
        thematicId: "",
        assessmentShowArr: [],

        no_of_question_trainer: "",
        previoustrainingSelectedTrainer: "",
        allMcqsQuestionsArrTrainer: [],
        allDescQuestionsArrTrainer: [],
        filteredQuestionsArrTrainer: [],
        selectedMcqsQuestionsArrTrainer: [],
        selectedDescQuestionsArrTrainer: [],
        addTrainerFeedbackForm: true,
        existTrainerFeedbackForm: false,
        trainerFeedbackShowArr: [],

        // Trainee
        no_of_question_trainee: "",
        allQuestionsArrTrainee: [],
        filteredQuestionsArrTrainee: [],
        selectedQuestionsArrTrainee: [],
        questionFormTrainee: true,
        filterFormTrainee: false,
        traineeFeedbackShowArr: [],
        addTraineeFeedForm: true,
        existTraineeFeedForm: false,
        previoustrainingSelectedTrainee: "",
        // End of Trainee
        training_status: "",
        // Modal data
        isModalOpen: false,
        commonQuestion: "",
        numbertype: "numberLimit",
        radiostype: "checkbox",
        qCheckboxArr: [{
            question: "",
            option1: "",
            option2: "",
            option3: "",
            option4: "",
            option5: "",
            type: "",
        }, ],
        level: "",
        levelSetting: {
            maxItems: 1,
            searchField: ["text"],
            plugins: ["remove_button"],
            placeholder: "Select level here",
        },
        leveltitleArr: [{
                text: "Basic",
                value: 6
            },
            {
                text: "Intermediate",
                value: 7
            },
            {
                text: "Advance",
                value: 8
            },
        ],
        correct1: 1,
        correct2: 0,
        correct3: 0,
        correct4: 0,
        correct5: 0,
        thematicAreaSelected: "",
        thematicAreaSettings: {
            maxItems: 3,
            plugins: ["remove_button"],
            placeholder: "Select thematic area here",
        },
        thematicAreasLoad: [],
        isDragging: false,
        draggingIndex: null,
        newPositionIndex: null,

    }),
    mounted() {
        axios.defaults.headers['Authorization'] = localStorage.getItem('token')
        this.trainingCode = this.$route.query.trainingId;
        this.openLoading();
        axios
            .get(
                process.env.VUE_APP_BASE_PATH +
                "/programOfficer/trainingsingle/get/" +
                this.trainingCode, {
                    headers: {
                        Authorization: localStorage.getItem("token"),
                    }
                }
            )
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }

                this.closeLoading();
                this.trainingId = response.data.training.id;
                this.training_status = response.data.training.trainingstatus;

                this.currentTraining();
                this.getPrevious();
                this.thematicId = response.data.training.thematic_id;
                this.allQuestions();
                this.isExistPreAssessment();
                this.showAssessment();
                // trainer
                this.showPreviousTrainings();
                this.allQuestionsTrainer();
                this.isExistTrainerFeedback();
                this.showTrainerFeedback();

                // trainee
                this.allQuestionsTrainee();
                this.isExistTraineeFeed();
                this.showTraineeFeedback();

                this.getThematicAreas()

            });

    },
    methods: {

        // onclick show wizard steps

        openLoading() {
            this.$vs.loading({
                type: "material"
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },
        printReport: function () {
            window.print();
        },
        toastSuccess(msg) {
            this.$bvToast.toast(msg, {
                title: "Success",
                autoHideDelay: 2000,
                variant: "success",
                solid: true
            });
        },
        toastError(msg) {
            this.$bvToast.toast(msg, {
                title: "Error",
                autoHideDelay: 2000,
                variant: "danger",
                solid: true
            });
        },
        // this will reset form elements
        resetFormElements: function resetFormElements() {
            this.thematicSelected = "";
            this.radios1 = "";
            this.previoustrainingSelected = "";
            this.allQuestions();
        },
        addOtherAssesment() {
            this.allQuestions();
            this.addPreassessmentForm = true;
            this.showAssessmentTable = false;
        },
        editAssesment() {
            this.allQuestions();
            this.addPreassessmentForm = true;
            this.showAssessmentTable = false;
            this.no_of_question = this.assessmentShowArr.length;
            this.easyPercent = this.assessmentShowArr[0].easy_percent;
            this.mediumPercent = this.assessmentShowArr[0].medium_percent;
            this.hardPercent = this.assessmentShowArr[0].hard_percent;
            this.assessmentShowArr.map(val => {
                this.selectedQuestionsArr.push([{
                    aid: val.id,
                    qid: val.question.id,
                    qtitle: val.question.title,
                    qfrequency: val.question.frequency,
                    qlevel: val.question.level,
                }]);
            });
            this.updatePercentages()
        },
        deleteAssesment() {
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/assessment/delete/id/" +
                    this.assessmentShowArr[0].training_id

                )
                .then(response => {

                    this.closeLoading();
                    if (response) {
                        this.addPreassessmentForm = true;
                        this.existPreassessmentForm = false;
                        this.assessmentShowArr = [];
                        this.$toasted.global.successMsg("Assessment has been deleted successfully.");
                    }
                });
        },
        // this will check if pre assessment already created or not
        isExistPreAssessment: function isExistPreAssessment() {
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/assessment/" +
                    this.trainingId +
                    "/check/get"

                )
                .then(response => {

                    this.closeLoading();
                    this.selectedQuestionsArr = [];
                    if (response.data.success != "" && response.data.success != null) {
                        this.addPreassessmentForm = false;
                        this.existPreassessmentForm = true;
                        this.showAssessmentTable = true;
                    } else {
                        this.addPreassessmentForm = true;
                        this.existPreassessmentForm = false;
                    }
                });
        },
        filterQuestions() {
            if (this.radios1 != "" || this.previoustrainingSelected != "") {
                this.allQuestionsArr = [];
                this.questionForm = false;
                this.filterForm = true;
                this.openLoading();
                axios
                    .post(
                        process.env.VUE_APP_BASE_PATH +
                        "/admin/current-training/filter/get", {
                            thematic: this.thematicId,
                            level: this.radios1,
                            priviousTraining: this.previoustrainingSelected
                        }
                    )
                    .then(response => {
                        this.closeLoading();
                        this.allQuestionsArr = [];
                        response.data.forEach((quiz) => {
                            if (quiz[0].qis_standard != "standard") {
                                this.allQuestionsArr.push(quiz);
                            }
                        })
                    });
            }
        },
        // this will show current training of a program officer
        currentTraining: function currentTraining() {
            let userId = JSON.parse(localStorage.getItem("currentUser"));
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/current-training/" +
                    this.trainingId +
                    "/" +
                    userId.id +
                    "/get"

                )
                .then(response => {

                    this.closeLoading();
                    this.trainingTitle = response.data.title;
                    this.startDate = response.data.startdate;
                    this.endDate = response.data.enddate;
                    this.thematicId = response.data.thematic_id;
                    this.getThematic();
                });
        },
        // this will show thematic areas
        getThematic: function getThematic() {
            this.openLoading();
            axios
                .post(process.env.VUE_APP_BASE_PATH + "/assessment/thematics/get", {
                    thematic: this.thematicId
                })
                .then(response => {

                    this.closeLoading();
                    this.thematicArr = response.data;
                });
        },
        // this will show privious trainings
        getPrevious: function getPrevious() {
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/admin/all-training/" +
                    this.trainingId +
                    "/previous/get"

                )
                .then(response => {

                    this.closeLoading();
                    this.previousTrainingArr = response.data;
                });
        },
        // this will show assessment which has been added
        showAssessment: function showAssessment() {
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/program-officer/training/assessment/" +
                    this.trainingId +
                    "/show"

                )
                .then(response => {

                    this.closeLoading();
                    this.assessmentShowArr = response.data;
                    this.showAssessmentTable = true;
                });
        },
        // this will show all questions
        allQuestions: function allQuestions() {
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/admin/all-questions/assessment/get/" + this.thematicId

                )
                .then(response => {

                    this.closeLoading();
                    this.allQuestionsArr = [];

                    response.data.forEach((quiz) => {
                        if (quiz[0].qis_standard != "standard") {
                            this.allQuestionsArr.push(quiz);
                        }
                    })

                    const qidsToRemove = new Set(this.selectedQuestionsArr.map(item => item[0].qid));
                    // Remove objects from payload1 that have qid values present in qidsToRemove
                    const filteredData = this.allQuestionsArr.filter(item => !qidsToRemove.has(item[0].qid));
                    this.allQuestionsArr = filteredData
                });
        },
        //... this will show selected questions

        async moveQuestion(question) {
            if (this.no_of_question !== "" && this.no_of_question !== 0) {
                if (this.selectedQuestionsArr.length + 1 > this.no_of_question) {
                    this.$toasted.global.errorMsg("Selected questions queue is full.");
                    return false;
                } else {
                    let checkValue = this.selectedQuestionsArr.some(function (value) {
                        return value[0].qid === question[0].qid;
                    });

                    if (checkValue) {
                        this.$toasted.global.errorMsg("Question was already moved.");
                    } else {
                        this.$toasted.global.successMsg("Question moved successfully!");
                        this.selectedQuestionsArr.push(question);
                        this.allQuestionsArr = this.allQuestionsArr.filter(
                            (q) => q[0].qid !== question[0].qid
                        );

                        this.updatePercentages();
                    }
                }
            } else {
                this.$toasted.global.errorMsg("Enter no of questions you want to select.");
            }
        },
        //... this will remove questions from selected queue
        removeQuestion(question) {
            this.allQuestionsArr.push(question);
            this.selectedQuestionsArr = this.selectedQuestionsArr.filter(
                (q) => q[0].qid !== question[0].qid
            );
            this.$toasted.global.errorMsg("Question removed from selected!");

            this.updatePercentages();
        },

        updatePercentages() {
            this.easyPercentArr = [];
            this.mediumPercentArr = [];
            this.hardPercentArr = [];
            this.selectedQuestionsArr.forEach(async element => {
                if (element[0].qlevel == 6) {
                    await this.easyPercentArr.push(element);
                }
                if (element[0].qlevel == 7) {
                    await this.mediumPercentArr.push(element);
                }
                if (element[0].qlevel == 8) {
                    await this.hardPercentArr.push(element);
                }
            });

            this.easyPercent = Math.floor(
                (this.easyPercentArr.length / this.no_of_question) * 100
            );
            this.mediumPercent = Math.floor(
                (this.mediumPercentArr.length / this.no_of_question) * 100
            );
            this.hardPercent = Math.floor(
                (this.hardPercentArr.length / this.no_of_question) * 100
            );

        },
        //... This will submit pre assessment form
        submitForm() {
            if (this.no_of_question != this.selectedQuestionsArr.length) {
                this.$toasted.global.errorMsg(
                    "Please check that no. of question is equal to selected question."
                );
            } else {
                let userId = JSON.parse(localStorage.getItem("currentUser"));
                this.openLoading();
                axios
                    .post(
                        process.env.VUE_APP_BASE_PATH +
                        "/admin/training/assessment/add", {
                            saveSelected: this.selectedQuestionsArr,
                            easy_percent: this.easyPercent,
                            medium_percent: this.mediumPercent,
                            hard_percent: this.hardPercent,
                            training_id: this.trainingId,
                            user_id: userId.id,
                        }
                    )
                    .then(response => {
                        this.closeLoading();
                        if (response.data.success) {
                            // empty all varaibles
                            this.allQuestionsArr = [];
                            this.selectedQuestionsArr = [];
                            this.questionForm = true;
                            this.filterForm = false;
                            this.thematicSelected = [];
                            this.level = "";
                            this.easyPercent = 0;
                            this.mediumPercent = 0;
                            this.hardPercent = 0;
                            this.addPreassessmentForm = false;
                            this.existPreassessmentForm = true;
                            this.showAssessment();
                            // End empty all varaibles
                            this.$toasted.global.successMsg("Assessment has been created successfully.");
                        } else {
                            this.$toasted.global.errorMsg(
                                "Error: Something went wrong while creating Assessment."
                            );
                        }
                    });
            }
        },
        // This will submit edit assessment form
        submitEditForm() {
            if (this.no_of_question != this.selectedQuestionsArr.length) {
                this.$toasted.global.errorMsg(
                    "Please check that no. of question is equal to selected question."
                );
            } else {
                let userId = JSON.parse(localStorage.getItem("currentUser"));
                this.openLoading();
                axios
                    .post(
                        process.env.VUE_APP_BASE_PATH +
                        "/admin/training/assessment/update", {
                            saveSelected: this.selectedQuestionsArr,
                            easy_percent: this.easyPercent,
                            medium_percent: this.mediumPercent,
                            hard_percent: this.hardPercent,
                            training_id: this.trainingId,
                            user_id: userId.id
                        }
                    )
                    .then(response => {
                        this.closeLoading();
                        if (response.data.success) {
                            // empty all varaibles
                            this.allQuestionsArr = [];
                            this.selectedQuestionsArr = [];
                            this.questionForm = true;
                            this.filterForm = false;
                            this.thematicSelected = [];
                            this.level = "";
                            this.easyPercent = 0;
                            this.mediumPercent = 0;
                            this.hardPercent = 0;
                            this.addPreassessmentForm = false;
                            this.existPreassessmentForm = true;
                            this.showAssessment();
                            // End empty all varaibles
                            this.$toasted.global.successMsg("Assessment has been updated successfully.");
                        } else {
                            this.$toasted.global.errorMsg(
                                "Error: Something went wrong while creating Assessment."
                            );
                        }
                    });
            }
        },
        // End Assessments questions
        // this will check if trainer feedback already created or not
        isExistTrainerFeedback: function isExistTrainerFeedback() {
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/trainer-feedback/" +
                    this.trainingId +
                    "/check/get"

                )
                .then(response => {

                    this.closeLoading();
                    if (response.data.success != "" && response.data.success != null) {
                        this.addTrainerFeedbackForm = false;
                        this.existTrainerFeedbackForm = true;
                    } else {
                        this.addTrainerFeedbackForm = true;
                        this.existTrainerFeedbackForm = false;
                    }
                });
        },
        // this will show trainer feedback which has been added
        showTrainerFeedback: function showTrainerFeedback() {
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/program-officer/training/trainer-feedback/" +
                    this.trainingId +
                    "/show"

                )
                .then(response => {

                    this.closeLoading();
                    this.trainerFeedbackShowArr = response.data;
                });
        },
        // this will show previous trainings
        showPreviousTrainings: function showPreviousTrainings() {
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/previous-trainings/" +
                    this.trainingId +
                    "/trainer-feedback/get"

                )
                .then(response => {

                    this.closeLoading();
                    this.previousTrainingArr = response.data;
                });
        },
        // this will show all questions
        allQuestionsTrainer: function allQuestionsTrainer() {
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/admin/all-questions/trainer-feedback/get"

                )
                .then(response => {

                    this.closeLoading();
                    response.data.forEach(element => {
                        if (element[0].qtype == "checkbox") {
                            this.allMcqsQuestionsArrTrainer.push(element);
                        } else {
                            this.allDescQuestionsArrTrainer.push(element);
                        }
                    });
                });
        },
        // this will show selected mcqs questions
        async moveMcqsQuestionTrainer(val, qid) {
            if (this.no_of_question_trainer != "" && this.no_of_question_trainer != 0) {
                if (
                    this.selectedDescQuestionsArrTrainer.length +
                    this.selectedMcqsQuestionsArrTrainer.length >=
                    this.no_of_question_trainer
                ) {
                    this.$toasted.global.errorMsg("Selected questions queue is full.");
                    return false;
                } else {
                    let checkValue = this.selectedMcqsQuestionsArrTrainer.some(function (value) {
                        return value[0].qid == qid;
                    });

                    if (checkValue == true) {
                        this.$toasted.global.errorMsg("Question was already moved.");
                    } else {
                        // this.moveScrollTo();
                        this.$toasted.global.successMsg("Question moved successfully!");
                        this.selectedMcqsQuestionsArrTrainer.push(this.allMcqsQuestionsArrTrainer[val]);
                        this.allMcqsQuestionsArrTrainer.splice(val, 1);
                    }
                }
            } else {
                this.$toasted.global.errorMsg("Enter no of questions you want to select.");
            }
        },
        // this will remove mcqs questions from selected queue
        removeMcqsQuestionTrainer(val) {
            this.allMcqsQuestionsArrTrainer.push(this.selectedMcqsQuestionsArrTrainer[val]);
            this.selectedMcqsQuestionsArrTrainer.splice(val, 1);
            this.$toasted.global.errorMsg("Question removed from MCQs selected!");
        },

        // this will show selected desc questions
        async moveDescQuestionTrainer(val, qid) {
            if (this.no_of_question_trainer != "" && this.no_of_question_trainer != 0) {
                if (
                    this.selectedDescQuestionsArrTrainer.length +
                    this.selectedMcqsQuestionsArrTrainer.length >=
                    this.no_of_question_trainer
                ) {
                    this.$toasted.global.errorMsg("Selected questions queue is full.");
                    return false;
                } else {
                    let checkValue = this.selectedDescQuestionsArrTrainer.some(function (value) {
                        return value[0].qid == qid;
                    });

                    if (checkValue == true) {
                        this.$toasted.global.errorMsg("Question was already moved to descriptive list.");
                    } else {
                        // this.moveScrollTo();
                        this.$toasted.global.successMsg(
                            "Question moved to descriptive list successfully!"
                        );
                        this.selectedDescQuestionsArrTrainer.push(this.allDescQuestionsArrTrainer[val]);
                        this.allDescQuestionsArrTrainer.splice(val, 1);
                    }
                }
            } else {
                this.$toasted.global.errorMsg("Enter no of questions you want to select.");
            }
        },
        // this will remove mcqs questions from selected queue
        removeDescQuestionTrainer(val) {
            this.allDescQuestionsArrTrainer.push(this.selectedDescQuestionsArrTrainer[val]);
            this.selectedDescQuestionsArrTrainer.splice(val, 1);
            this.$toasted.global.errorMsg("Question removed from Descriptive selected list!");
        },

        // This will submit trainees feedback form form
        submitFormTrainer() {
            if (
                this.no_of_question_trainer !=
                this.selectedMcqsQuestionsArrTrainer.length +
                this.selectedDescQuestionsArrTrainer.length
            ) {
                this.$toasted.global.errorMsg(
                    "Please check that no. of question is equal to selected question."
                );
            } else {
                let userId = JSON.parse(localStorage.getItem("currentUser"));
                this.openLoading();
                axios
                    .post(
                        process.env.VUE_APP_BASE_PATH +
                        "/admin/program-officer/trainer-feedback/add", {
                            mcqsArr: this.selectedMcqsQuestionsArrTrainer,
                            descArr: this.selectedDescQuestionsArrTrainer,
                            training_id: this.trainingId,
                            user_id: userId.id
                        }
                    )
                    .then(response => {
                        this.closeLoading();
                        if (response.data.success) {
                            // empty all varaibles
                            this.allMcqsQuestionsArrTrainer = [];
                            this.allDescQuestionsArrTrainer = [];
                            this.selectedMcqsQuestionsArrTrainer = [];
                            this.selectedDescQuestionsArrTrainer = [];
                            this.showTrainerFeedback();
                            this.addTrainerFeedbackForm = false;
                            this.existTrainerFeedbackForm = true;
                            // End empty all varaibles
                            this.$toasted.global.successMsg(
                                "Trainer Feedback has been created successfully."
                            );
                        } else {
                            this.$toasted.global.errorMsg(
                                "Error: Something went wrong while creating Trainer Feedback."
                            );
                        }
                    });
            }
        },
        // End trainer feedback
        // this will reset form elements
        resetFormElementsTrainee: function resetFormElementsTrainee() {
            this.previoustrainingSelectedTrainee = "";
        },
        // this will check if Trainee feedback already created or not
        isExistTraineeFeed: function isExistTraineeFeed() {
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/trainee-feedback/" +
                    this.trainingId +
                    "/check/get"

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    if (response.data.success != "" && response.data.success != null) {
                        this.addTraineeFeedForm = false;
                        this.existTraineeFeedForm = true;
                    } else {
                        this.addTraineeFeedForm = true;
                        this.existTraineeFeedForm = false;
                    }
                });
        },
        // this will show trainer feedback which has been added
        showTraineeFeedback: function showTraineeFeedback() {
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/program-officer/training/trainee-feedback/" +
                    this.trainingId +
                    "/show"

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.traineeFeedbackShowArr = response.data;
                });
        },
        // this will show all questions
        allQuestionsTrainee: function allQuestionsTrainee() {
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/admin/all-questions/trainee-feedback/get"

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.allQuestionsArrTrainee = response.data;
                });
        },
        // this will show selected questions
        async moveQuestionTrainee(val, qid) {
            if (this.no_of_question_trainee != "" && this.no_of_question_trainee != 0) {
                if (this.selectedQuestionsArrTrainee.length + 1 > this.no_of_question_trainee) {
                    this.$toasted.global.errorMsg("Selected questions queue is full.");
                    return false;
                } else {
                    let checkValue = this.selectedQuestionsArrTrainee.some(function (value) {
                        return value[0].qid == qid;
                    });

                    if (checkValue == true) {
                        this.$toasted.global.errorMsg("Question was already moved.");
                    } else {
                        // this.moveScrollTo();
                        this.$toasted.global.successMsg("Question moved successfully!");
                        this.selectedQuestionsArrTrainee.push(this.allQuestionsArrTrainee[val]);
                        this.allQuestionsArrTrainee.splice(val, 1);
                    }
                }
            } else {
                this.$toasted.global.errorMsg("Enter no of questions you want to select.");
            }
        },
        // this will remove questions from selected queue
        removeQuestionTrainee(val) {
            this.allQuestionsArrTrainee.push(this.selectedQuestionsArrTrainee[val]);
            this.selectedQuestionsArrTrainee.splice(val, 1);
            this.$toasted.global.errorMsg("Question removed from selected!");
        },
        // This will submit trainee feedbackform
        submitFormTrainee() {
            if (this.no_of_question_trainee != this.selectedQuestionsArrTrainee.length) {
                this.$toasted.global.errorMsg(
                    "Please check that no. of question is equal to selected question."
                );
            } else {
                let userId = JSON.parse(localStorage.getItem("currentUser"));
                this.openLoading();
                axios
                    .post(
                        process.env.VUE_APP_BASE_PATH +
                        "/admin/training/trainee-feedback/add", {
                            saveSelected: this.selectedQuestionsArrTrainee,
                            training_id: this.trainingId,
                            user_id: userId.id
                        }
                    )
                    .then(response => {
                        this.closeLoading();
                        if (response.data.success) {
                            // empty all varaibles
                            this.allQuestionsArrTrainee = [];
                            this.selectedQuestionsArrTrainee = [];
                            this.showTraineeFeedback();
                            this.questionFormTrainee = true;
                            this.addTraineeFeedForm = false;
                            this.existTraineeFeedForm = true;
                            // End empty all varaibles
                            this.$toasted.global.successMsg(
                                "Trainee Feedback has been created successfully."
                            );
                        } else {
                            this.$toasted.global.errorMsg(
                                "Error: Something went wrong while creating Trainee Feedback."
                            );
                        }
                    });
            }
        },

        addAllQuestions() {
            this.selectedQuestionsArr.push(...this.allQuestionsArr);
            this.allQuestionsArr = [];
            this.easyPercentArr = [];
            this.mediumPercentArr = [];
            this.hardPercentArr = [];

            this.no_of_question = this.selectedQuestionsArr.length,
                this.selectedQuestionsArr.forEach(element => {
                    if (element[0].qlevel == 6) {
                        this.easyPercentArr.push(element);
                    }
                    if (element[0].qlevel == 7) {
                        this.mediumPercentArr.push(element);
                    }
                    if (element[0].qlevel == 8) {
                        this.hardPercentArr.push(element);
                    }
                });

            const selectedCount = this.selectedQuestionsArr.length;
            this.easyPercent = Math.floor((this.easyPercentArr.length / selectedCount) * 100);
            this.mediumPercent = Math.floor((this.mediumPercentArr.length / selectedCount) * 100);
            this.hardPercent = Math.floor((this.hardPercentArr.length / selectedCount) * 100);

            this.$toasted.global.successMsg("All questions added successfully!");

        },
        getThematicAreas() {

            axios
                .get(process.env.VUE_APP_BASE_PATH + "/thematics/get")
                .then((response) => {
                    this.thematicAreasLoad = response.data;
                });
        },
        openModal() {
            this.isModalOpen = true;
        },
        closeModal() {
            this.isModalOpen = false;
        },
        createQuestionBank(e) {

            e.preventDefault();
            // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
            let self = this;
            this.inValid = [];

            if (!this.level) {
                this.inValid.push("Select Question Level please.");
            }
            if (!this.thematicAreaSelected) {
                this.inValid.push("Select Thematic Area please.");
            }
            if (!this.commonQuestion) {
                this.inValid.push("Question statement is required.");
            }
            if (!this.qCheckboxArr[0].option1) {
                this.inValid.push("Option number 1 is required.");
            }
            if (!this.qCheckboxArr[0].option2) {
                this.inValid.push("Option number 2 is required.");
            }

            for (var i = 0; i < this.inValid.length; i++) {
                this.$toasted.global.errorMsg(this.inValid[i]);
            }
            if (!this.inValid.length) {
                this.openLoading();
                axios
                    .post(
                        process.env.VUE_APP_BASE_PATH +
                        "/program-officer/questionbank/create", {
                            user_id: JSON.parse(localStorage.getItem("currentUser")).id,
                            category: '1',
                            thematicArea: this.thematicAreaSelected,
                            level: this.level,
                            question: this.commonQuestion,
                            optionNo: this.numbertype,
                            questionType: this.radiostype,
                            option1: this.qCheckboxArr[0].option1,
                            correct1: this.correct1,
                            option2: this.qCheckboxArr[0].option2,
                            correct2: this.correct2,
                            option3: this.qCheckboxArr[0].option3,
                            correct3: this.correct3,
                            option4: this.qCheckboxArr[0].option4,
                            correct4: this.correct4,
                            option5: this.qCheckboxArr[0].option5,
                            correct5: this.correct5,
                            descriptiveAnswer: '',
                            trueFalseRadio: "",
                            yesNoRadio: "",
                            standard: "",
                            standardTypeNow: "",
                        }
                    )
                    .then((response) => {
                        this.closeLoading();
                        if (response.data.success) {
                            self.toastSuccess("Record has been added successfully!");
                            self.resetForm();
                            self.allQuestions();
                            self.closeModal()
                        } else if (response.data.error) {
                            throw response.data.error;
                        }
                    })
                    .catch((error) => {
                        self.toastError(error);
                    });
            }
        },
        resetForm() {
            this.category = "";
            this.thematicAreaSelected = "";
            this.level = "";
            this.commonQuestion = "";
            this.qCheckboxArr[0].option1 = "";
            this.qCheckboxArr[0].option2 = "";
            this.qCheckboxArr[0].option3 = "";
            this.qCheckboxArr[0].option4 = "";
            this.qCheckboxArr[0].option5 = "";
        },

        onDragStart(event) {
            this.draggingIndex = event.oldIndex;
            this.isDragging = true;
        },
        onDragEnd(event) {
            this.newPositionIndex = event.newIndex;
            this.isDragging = false;
            setTimeout(() => {
                this.newPositionIndex = null;
            }, 1000); // Remove highlight after 1 second
        },
        onMouseDown() {
            this.isDragging = true;
        },
        onMouseUp() {
            this.isDragging = false;
        },
        

  async editTrainerFeedback() {
    // Step 1: Fetch existing feedback questions for this training
    try {
      this.openLoading();
    //   const response = await axios.get(`/trainer-feedback/${this.trainingId}/edit`);
      
      // Assuming response.data contains the existing questions array
      const existingQuestions = this.trainerFeedbackShowArr; 

      // Clear previous selections
      this.selectedMcqsQuestionsArrTrainer = [];
      this.selectedDescQuestionsArrTrainer = [];

      // Clear available questions arrays
      this.allMcqsQuestionsArrTrainer = [];
      this.allDescQuestionsArrTrainer = [];

      // Step 2: Populate selected questions
      existingQuestions.forEach(q => {
        if (q.type === 'mcqs') {
          this.selectedMcqsQuestionsArrTrainer.push([{
            aid: q.id,
            qid: q.question.id,
            qtitle: q.question.title,
           
          }]);
        } else if (q.type === 'descriptive') {
          this.selectedDescQuestionsArrTrainer.push([{
            aid: q.id,
            qid: q.question.id,
            qtitle: q.question.title,
            
          }]);
        }
      });

      // Step 3: Load all questions (excluding already selected)
      await this.allQuestionsTrainer();

      // Remove already selected questions from the 'allQuestions' arrays
      const selectedQids = new Set([
        ...this.selectedMcqsQuestionsArrTrainer.map(q => q[0].qid),
        ...this.selectedDescQuestionsArrTrainer.map(q => q[0].qid),
      ]);

      this.allMcqsQuestionsArrTrainer = this.allMcqsQuestionsArrTrainer.filter(
        q => !selectedQids.has(q[0].qid)
      );
      this.allDescQuestionsArrTrainer = this.allDescQuestionsArrTrainer.filter(
        q => !selectedQids.has(q[0].qid)
      );

      // Step 4: Show the form for editing
      this.addTrainerFeedbackForm = true;
      this.existTrainerFeedbackForm = false;
    } catch (error) {
      this.closeLoading();
      this.toastError('Failed to load existing trainer feedback.');
    } finally {
      this.closeLoading();
    }
  },
  

    },
    computed: {
        filterData: function () {

            return this.allQuestionsArr?.filter((items) => {

                if (
                    String(items[0].qtitle)
                    .toLowerCase()
                    .indexOf(this.searchQuery.toLowerCase()) !== -1
                ) {
                    return true;
                }

                return false;
            });
        },
    },
    watch: {
        no_of_question() {
            if (
                this.selectedQuestionsArr.length > 0 &&
                this.no_of_question < this.selectedQuestionsArr.length
            ) {
                this.$toasted.global.errorMsg(
                    "No. of questions in input, decreased from selected questions in queue."
                );
            } else if (
                this.selectedQuestionsArr.length > 0 &&
                this.no_of_question == this.selectedQuestionsArr.length
            ) {
                return true;
            } else if (this.no_of_question <= 0) {
                this.$toasted.global.errorMsg("Number of question(s) must be greater than zero.");
            } else {
                this.$toasted.global.successMsg("Now you can move questions.");
            }
        },
        // End assessments
        no_of_question_trainer() {
            if (
                this.selectedMcqsQuestionsArrTrainer.length > 0 &&
                this.selectedDescQuestionsArrTrainer.length > 0 &&
                this.no_of_question_trainer <
                (this.selectedMcqsQuestionsArrTrainer.length ||
                    this.selectedDescQuestionsArrTrainer.length)
            ) {
                this.$toasted.global.errorMsg(
                    "No. of questions in input, decreased from selected questions in queue."
                );
            } else if (
                (this.selectedMcqsQuestionsArrTrainer.length ||
                    this.selectedDescQuestionsArrTrainer.length) > 0 &&
                this.no_of_question_trainer ==
                (this.selectedMcqsQuestionsArrTrainer.length ||
                    this.selectedDescQuestionsArrTrainer.length)
            ) {
                return true;
            } else if (this.no_of_question_trainer <= 0) {
                this.$toasted.global.errorMsg("Number of question(s) must be greater than zero.");
            } else {
                this.$toasted.global.successMsg("Now you can move questions.");
            }
        },
        // End of Trainer

        no_of_question_trainee() {
            if (
                this.selectedQuestionsArrTrainee.length > 0 &&
                this.no_of_question_trainee < this.selectedQuestionsArrTrainee.length
            ) {
                this.$toasted.global.errorMsg(
                    "No. of questions in input, decreased from selected questions in queue."
                );
            } else if (
                this.selectedQuestionsArrTrainee.length > 0 &&
                this.no_of_question_trainee == this.selectedQuestionsArrTrainee.length
            ) {
                return true;
            } else if (this.no_of_question_trainee == 0) {
                this.$toasted.global.errorMsg("Number of question(s) must be greater than zero.");
            } else {
                this.$toasted.global.successMsg("Now you can move questions.");
            }
        },
        // End of Trainee

        // Modal Data
        numbertype() {
            this.correct1 = 1;
            this.correct2 = 0;
            this.correct3 = 0;
            this.correct4 = 0;
            this.correct5 = 0;
        },
        radiostype() {
            this.commonQuestion = "";
            this.qCheckboxArr[0].option1 = "";
            this.qCheckboxArr[0].option2 = "";
            this.qCheckboxArr[0].option3 = "";
            this.qCheckboxArr[0].option4 = "";
            this.qCheckboxArr[0].option5 = "";
            this.qCheckboxArr[0].correct = "";
        },
        correct1() {
            this.correct2 = 0;
            this.correct3 = 0;
            this.correct4 = 0;
            this.correct5 = 0;
        },
        correct2() {
            this.correct1 = 0;
            this.correct3 = 0;
            this.correct4 = 0;
            this.correct5 = 0;
        },
        correct3() {
            this.correct2 = 0;
            this.correct1 = 0;
            this.correct4 = 0;
            this.correct5 = 0;
        },
        correct4() {
            this.correct2 = 0;
            this.correct3 = 0;
            this.correct1 = 0;
            this.correct5 = 0;
        },
        correct5() {
            this.correct2 = 0;
            this.correct3 = 0;
            this.correct4 = 0;
            this.correct1 = 0;
        },
        select9(val) {
            this.correct1 = 1;
            this.correct2 = 0;
            this.correct3 = 0;
            this.correct4 = 0;
            this.correct5 = 0;
            this.commonQuestion = "";
            this.qCheckboxArr[0].option1 = "";
            this.qCheckboxArr[0].option2 = "";
            this.qCheckboxArr[0].option3 = "";
            this.qCheckboxArr[0].option4 = "";
            this.qCheckboxArr[0].option5 = "";
            this.qCheckboxArr[0].correct = "";
            this.thematicAreaSelected = "";
            this.level = "";
            if (val != 2) {
                this.radiostype = "checkbox";
            }
        },
    },
    components: {
        Selectize,
        draggable
    },

};
</script>

<style scoped>
#grad1 {
    background-color: #fff;
}

#msform {
    text-align: center;
    position: relative;
    margin-top: 20px;
}

#msform fieldset .form-card {
    background: white;
    border: 0 none;
    border-radius: 0px;
    box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.2);
    padding: 20px 40px 30px 40px;
    box-sizing: border-box;
    width: 94%;
    margin: 0 3% 20px 3%;
    position: relative;
}

#msform fieldset {
    padding: 10px;
    background: #f7f7f7;
    border: 0 none;
    border-radius: 2rem;
    box-sizing: border-box;
    width: 100%;
    margin: 0;
    border: 2px solid #ccc;
    padding-bottom: 20px;
    position: relative;
}

#msform fieldset:not(:first-of-type) {
    display: none;
}

#msform fieldset .form-card {
    text-align: left;
    color: #9e9e9e;
}

#msform .action-button {
    width: 100px;
    background: skyblue;
    font-weight: bold;
    color: white;
    border: 0 none;
    border-radius: 0px;
    cursor: pointer;
    padding: 10px 5px;
    margin: 10px 5px;
}

#msform .action-button:hover,
#msform .action-button:focus {
    box-shadow: 0 0 0 2px white, 0 0 0 3px skyblue;
}

#msform .action-button-previous {
    width: 100px;
    background: #616161;
    font-weight: bold;
    color: white;
    border: 0 none;
    border-radius: 0px;
    cursor: pointer;
    padding: 10px 5px;
    margin: 10px 5px;
}

#msform .action-button-previous:hover,
#msform .action-button-previous:focus {
    box-shadow: 0 0 0 2px white, 0 0 0 3px #616161;
}

select.list-dt {
    border: none;
    outline: 0;
    border-bottom: 1px solid #ccc;
    padding: 2px 5px 3px 5px;
    margin: 2px;
}

select.list-dt:focus {
    border-bottom: 2px solid skyblue;
}

.card {
    z-index: 0;
    border: none;
    border-radius: 0.5rem;
    position: relative;
}

.custom-tabs .vs-tabs--btn {
    font-size: large !important;
    padding: 10px 20px !important;
    font-weight: 500;
    margin: 0px 10px;
}

.custom-tabs .line-vs-tabs {
    display: none !important;
}

.custom-tabs .vs-tabs--ul {
    /* webkit-box-shadow: none !important; */
    box-shadow: none !important;
}

.fs-title {
    font-size: 25px;
    color: #2c3e50;
    margin-bottom: 10px;
    font-weight: bold;
    text-align: left;
}

.radio-group {
    position: relative;
    margin-bottom: 25px;
}

.radio {
    display: inline-block;
    width: 204;
    height: 104;
    border-radius: 0;
    background: lightblue;
    box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.2);
    box-sizing: border-box;
    cursor: pointer;
    margin: 8px 2px;
}

.radio:hover {
    box-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.3);
}

.radio.selected {
    box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.1);
}

.fit-image {
    width: 100%;
    object-fit: cover;
}

.vs-collapse-item--content {
    max-height: 100vh !important;
    /* min-height: 168px; */
    overflow: scroll !important;
}

.ans {
    display: inline-block;
    max-width: 200px;
    /* Set the max-width to 200px */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
    font-size: 14px;
    font-weight: 400;
}

.bg-blue {
    background-color: #5DADE2;
    color: white;
}

.modal {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
    background-color: #fff;
    padding: 20px;
    border-radius: 5px;
    width: 80%
}

.close {
    text-align: end;
    font-size: 28px;
    font-weight: bold;
}

/* Style for the container div during drag */
.dragging-container {
    background-color: rgba(0, 123, 255, 0.1);
    /* Light blue background */
    transition: background-color 0.2s ease-in-out;
}

/* Style for the items being dragged */
.dragging-item {
    position: relative;
    background-color: rgba(52, 152, 219, 0.1);
}

/* Animation for new position */
.new-position {
    animation: highlight 0.5s ease-in-out;
}

.dots-icon {
    display: none;
    /* Initially hide the icon */
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 20px;
    color: #6c757d;
    /* Icon color, adjust as needed */
}

#scrollToQuestion:hover .dots-icon {
    display: block;
}

@keyframes highlight {
    0% {
        background-color: rgba(52, 152, 219, 0.1);
    }

    100% {
        background-color: rgba(52, 152, 219, 0);
    }
}

/* Hand cursor for draggable items */
.grab {
    cursor: grab;
}

.grabbing {
    cursor: grabbing;
}
</style>
